import React from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals.js";


document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
});


//const container = document.getElementById("root");
//const root = createRoot(container);
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);

/*
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
*/


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
